<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

document.querySelectorAll('.list-menu--inline > li:nth-child(3) .site-nav:nth-of-type(5) .text').forEach((el) => {
    el.innerHTML = el.innerHTML
        .replace(/NoLo/g, '<span class="bold-word">NoLo</span>')
        .replace(/Forg3d/g, '<span class="bold-word">Forg3d</span>')
        .replace(/Imperium/g, '<span class="bold-word">Imperium</span>')
        .replace(/Horizon/g, '<span class="bold-word">Horizon</span>')
        .replace(/Prism/g, '<span class="bold-word">Prism</span>');
});
